























































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";

import { uploadChatChannelFile } from "@/api/_request";
import ChatModel, { GetDirectChannelDto, GetMessagesDto } from "@/api/chat.model";
import clientAppModel from "@/api/client_app.model";
import userAppModel from "@/api/user_app.model";
import { Client } from "@/entities/client";
import { showErrorAlert, showSuccessAlert } from "@/helpers";
import { getMask } from "@/helpers/utils";
import {
	ChatChannel,
	ChatMember,
	ChatMessage,
	ChatMessageAction,
	ChatMessageKind,
	ChatMessageStatus,
} from "@/interfaces/chat";
import { IUser, UserWorkStatus } from "@/interfaces/user";
import ChatMemberCard from "@/layouts/components/ChatMemberCard.vue";
import ChatMessageCard from "@/layouts/components/ChatMessageCard.vue";
import ChooseChannel from "@/layouts/components/ChooseChannel.vue";
import ChooseClient from "@/layouts/components/ChooseClient.vue";
import ChooseUser from "@/layouts/components/ChooseUser.vue";
import ConfirmationModal from "@/layouts/components/ConfirmationModal.vue";
import CustomerProfile from "@/layouts/components/CustomerProfile.vue";
import GuideBalloon from "@/layouts/components/GuideBalloon.vue";
import Input from "@/layouts/components/Input.vue";
import MainChatMember from "@/layouts/components/MainChatMember.vue";
import MediaViewer from "@/layouts/components/MediaViewer.vue";
import OpenChannelWithNumber from "@/layouts/components/OpenChannelWithNumber.vue";
import UserCalendar from "@/layouts/components/UserCalendar.vue";
import UserCard from "@/layouts/components/UserCard.vue";
import {
	closeSocket,
	getTimestamp,
	initChat,
	sendMessageSocket,
	socketStatus,
	transferChannel,
} from "@/socket/webSocket";
import {
	BIconArrowDown,
	BIconArrowLeftRight,
	BIconCaretRight,
	BIconChatLeftDots,
	BIconCheck2,
	BIconEmojiSmile,
	BIconPaperclip,
	BIconSearch,
	BSpinner,
	BootstrapVue,
	IconsPlugin,
} from "bootstrap-vue";
import debounce from "debounce";
import { v4 as uuidv4 } from "uuid";
import { VEmojiPicker } from "v-emoji-picker";
import ChooseHSM from "../../layouts/components/ChooseHSM.vue";
import ChooseStandardMessage from "../../layouts/components/ChooseStandardMessage.vue";

type ChannelReconciliationPurpose =
	| "mounted"
	| "registered"
	| "refreshChannels"
	| "acknowledged"
	| "missingChannelDiscovery"
	| "createOrOpen"
	| "pin"
	| "close";

interface ChannelRequest {
	identifier: number;
	startedAt: number;
	purposes: Set<ChannelReconciliationPurpose>;
	componentGeneration: number;
	completion?: Promise<void>;
}

interface ChannelDiscovery {
	attemptCount: number;
	latestMessage: ChatMessage;
	retryTimer: ReturnType<typeof setTimeout> | undefined;
	isRequestInProgress: boolean;
}

interface WebSocketChannelFact {
	channelIdentifier: string;
	sequence: number;
	latestMessage: ChatMessage;
	promotedPosition: number;
	pendingRequestIdentifiers: Set<number>;
}

const MISSING_CHANNEL_RETRY_INITIAL_DELAY_MILLISECONDS = 250;
const MISSING_CHANNEL_RETRY_BACKOFF_MULTIPLIER = 2;
const MISSING_CHANNEL_RETRY_MAXIMUM_ATTEMPTS = 4;
const ACKNOWLEDGED_MESSAGE_RECONCILIATION_DELAY_MILLISECONDS = 2000;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

@Component({
	components: {
		"chat-member-card": ChatMemberCard,
		"chat-message-card": ChatMessageCard,
		"journey-input": Input,
		BSpinner,
		UserCard,
		VEmojiPicker,
		BIconEmojiSmile,
		BIconPaperclip,
		BIconCaretRight,
		BIconChatLeftDots,
		BIconSearch,
		BIconArrowLeftRight,
		BIconArrowDown,
		BIconCheck2,
		GuideBalloon,
		MainChatMember,
		"choose-client": ChooseClient,
		"choose-user": ChooseUser,
		"user-calendar": UserCalendar,
		"choose-hsm": ChooseHSM,
		"choose-standard-message": ChooseStandardMessage,
		"confirmation-modal": ConfirmationModal,
		"choose-channel": ChooseChannel,
		"open-channel-with-number": OpenChannelWithNumber,
		CustomerProfile,
		MediaViewer,
	},
})
export default class Chat extends Vue {
	model: any = clientAppModel;
	chatModel = ChatModel;
	userAppModel = userAppModel;
	searchParam: string = "";
	clientPhoneNumberText: string = "";
	clientHeader = [
		{ key: "name", kind: "userName" },
		{ key: "lastName", kind: "userName" },
		{
			content: [{ key: "phoneNumber" }],
		},
	];

	currentPage = 1;
	pageLimit = 15;

	activeUser: Partial<IUser> = {};

	clientsList: Client[] = [];
	channelList: ChatChannel[] = [];
	isClientsLoading = false;
	isChannelsLoading = false;
	isChatLoading = false;
	isChatOpened = false;
	clientPhoneNumber = "";
	mainChatChannelMember: { fullName: string; id: string } = {
		fullName: "",
		id: "",
	};
	messageText = "";
	emojiModalIsOpen = false;
	mainChatMemberModalIsOpen = false;
	currentChatChannel: ChatChannel;
	socket: any;

	messages: ChatMessage[] = [];
	foundClientId: string = "";
	customerProfileComponentKey: number = 0;
	mainChatMemberComponentKey: number = 0;
	channelListComponentKey: number = 0;
	sideToShow: "left" | "right" = "left";

	hsmModalIsOpen: boolean = false;
	standardModalIsOpen: boolean = false;
	clientModalIsOpen: boolean = false;
	userModalIsOpen: boolean = false;
	userCalendarIsOpen: boolean = false;
	openChannelWithNumberIsOpen: boolean = false;
	chooseChannelIsOpen: boolean = false;
	confirmationModalIsOpen: boolean = false;
	eventType: string = "";
	headerIconColor: string = "color: #8bb0be;";

	showScrollButton: boolean = false;
	lastScrollTop: number = 0;

	debouncedGetMoreMessages = debounce(this.loadMoreMessages, 300);
	debouncedHandleScroll = debounce(this.handleScroll, 50);

	workStatusIconStyle: string = "h-7 font-bold";
	mediaPreview: any = "";
	shouldShowUploadPreview: boolean = false;
	uploadedFile: { fileName: string } | undefined = undefined;
	fileType: string | undefined = undefined;
	isMediaUploading = false;

	shouldShowMessageSendAlert = true;
	isMessageSendAlertModalOpen = false;
	uploadInputKey = 0;

	socketStatus = socketStatus;

	isReconnection = false;

	currentTime = new Date();

	currentTimeInterval: number | null = null;

	isMediaCopy = false;

	// ChatMemberCard derives display state during mount, therefore list updates use new
	// channel references and explicitly remount the cards after reconciliation.
	channelRequestSequence = 0;
	lastAppliedChannelRequestIdentifier = 0;
	channelReconciliationGeneration = 0;
	webSocketFactSequence = 0;
	pendingChannelRequests = new Map<number, ChannelRequest>();
	missingChannelDiscoveries = new Map<string, ChannelDiscovery>();
	webSocketChannelFacts = new Map<string, WebSocketChannelFact>();
	acknowledgedOptimisticMessages = new Map<
		string,
		{ chatChannelId: string; messageId: string; timer: ReturnType<typeof setTimeout> }
	>();
	messageSnapshotRequestSequence = 0;

	async uploadFile(event?: any, pastedFile?: File) {
		try {
			this.isMediaUploading = true;
			this.mediaPreview = "";
			const file = pastedFile ? pastedFile : event.target.files[0];

			this.fileType = file.type.split("/").pop();

			this.shouldShowUploadPreview = true;
			this.uploadedFile = await uploadChatChannelFile(file, this.currentChatChannel.id);
			this.isMediaUploading = false;
			if (this.uploadedFile) {
				this.mediaPreview = window.URL.createObjectURL(file);
				const journeyInput = <HTMLInputElement>document.getElementById("journey-input");
				journeyInput.focus();
			}
			this.isMediaCopy = false;
		} catch (error) {
			this.isMediaUploading = false;
			this.shouldShowUploadPreview = false;
			showErrorAlert((<any>error)?.message ?? "Ocorreu um erro. Tente novamente.");
		}
	}

	saveSketch(text: string) {
		const chatSketchs = JSON.parse(sessionStorage.getItem("chatSketchs") || "[]") as Array<{
			chatId: string;
			sketch: string;
		}>;
		const chatSketchIndex = chatSketchs.findIndex(({ chatId: userId }) => this.currentChatChannel.id === userId);

		if (text !== "") {
			if (chatSketchIndex === -1) {
				chatSketchs.push({ sketch: text, chatId: this.currentChatChannel.id ?? "" });
			} else {
				chatSketchs[chatSketchIndex].sketch = text;
			}

			sessionStorage.setItem("chatSketchs", JSON.stringify(chatSketchs));
		} else {
			if (chatSketchIndex === -1) return;

			sessionStorage.setItem(
				"chatSketchs",
				JSON.stringify(chatSketchs.filter(({ chatId }) => chatId !== this.currentChatChannel.id)),
			);
		}
	}

	loadSketch() {
		const chatSketchs = JSON.parse(sessionStorage.getItem("chatSketchs") || "[]") as Array<{
			chatId: string;
			sketch: string;
		}>;
		const chatSketchIndex = chatSketchs.findIndex(({ chatId: userId }) => this.currentChatChannel.id === userId);

		if (chatSketchIndex === -1) return;

		this.messageText = chatSketchs[chatSketchIndex].sketch;
	}

	unsetUploadFileVariables() {
		this.shouldShowUploadPreview = false;
		this.uploadedFile = undefined;
		this.uploadInputKey += 1;
	}

	async mounted() {
		try {
			this.updateCurrentTime();
			this.isChannelsLoading = true;
			await this.getUserProfile();
			await this.getChannels("mounted");
			await this.initSocket();
			this.isChannelsLoading = false;
		} catch (error) {
			showErrorAlert((<any>error)?.message ?? "Ocorreu um erro. Tente novamente.");
		} finally {
			this.isChannelsLoading = false;
		}
	}

	async getUserProfile() {
		this.activeUser = await this.userAppModel.getProfile();
		this.changeWorkStatusIconColor();
	}

	async initSocket(isReconnection = false) {
		this.socket = await initChat(this.$store.state.auth._token);

		this.isReconnection = isReconnection;

		this.socket.onmessage = async (event: any) => {
			const newMessage = JSON.parse(event.data);
			await this.callFunctionBySocketAction(newMessage, newMessage.action);
		};

		this.socket.onclose = async () => {
			this.socketReconnection();
		};
	}

	async socketReconnection() {
		closeSocket();
		await this.initSocket(true);
	}

	async callFunctionBySocketAction(newMessage: any, action: ChatMessageAction) {
		switch (action) {
			case ChatMessageAction.REGISTERED:
				console.info(getTimestamp(), "[WS] Iniciando canal");
				if (this.isReconnection) {
					await this.getChannels("registered");
					if (this.currentChatChannel) {
						await this.startConversation(this.currentChatChannel, this.isReconnection);
					}
					this.isReconnection = false;
				}
				break;
			case ChatMessageAction.STATUS_CHANGE:
				this.updateChatMessageStatus(newMessage);
				break;
			case ChatMessageAction.NEW_MESSAGE:
				await this.addNewChatMessage(newMessage);
				break;
			case ChatMessageAction.REFRESH_CHANNELS:
				if (newMessage.chatChannel) {
					showSuccessAlert("Canal recebido por transferência adicionado na listagem.");
				}
				this.isChannelsLoading = true;
				await this.getChannels("refreshChannels");
				if (this.currentChatChannel && !this.channelList.find(channel => channel.id === this.currentChatChannel.id)) {
					this.updateChannelList();
					this.foundClientId = "";
					this.customerProfileComponentKey += 1;
				}
				this.isChannelsLoading = false;

				break;
			case ChatMessageAction.ACKNOWLEDGED:
				if (newMessage.clientMessageId && newMessage.messageId) {
					this.scheduleAcknowledgedMessageReconciliation(newMessage.clientMessageId, newMessage.messageId);
					break;
				}

				const { message } = newMessage;
				if (newMessage.message && message.chatChannel === this.currentChatChannel.id) {
					this.updateChannelList();
					await this.getChannels("acknowledged");
					this.isChannelsLoading = false;
					showSuccessAlert("Canal transferido com sucesso.");
				}
				break;
			case ChatMessageAction.ERROR:
				this.markOptimisticMessageAsFailed(newMessage.clientMessageId);
				const { error } = newMessage;
				showErrorAlert((<any>error)?.message ?? "Ocorreu um erro. Tente novamente.");
				break;
			default:
				break;
		}
	}

	updateChannelList() {
		this.isChannelsLoading = true;
		this.isChatOpened = false;
		this.messages = [];
	}

	updateChatMessageStatus(newMessage: any) {
		if (newMessage.chatChannel === this.currentChatChannel?.id) {
			const foundMessageIndex = this.messages.findIndex(message => message.id === newMessage.id);
			if (foundMessageIndex !== -1 && this.messages[foundMessageIndex].status !== ChatMessageStatus.READ) {
				this.messages[foundMessageIndex].status = newMessage.status;
			}

			if (newMessage.status === ChatMessageStatus.UNDELIVERED) {
				//Possível problema de envio de HSM com o canal já liberado para mensagens livres
				showErrorAlert("Falha no envio da mensagem");
			}
		}
	}

	async assignMessageAndUpdateList(message: ChatMessage, index: number) {
		const updatedChannel = { ...this.channelList[index], lastChatMessage: message };
		const nextChannelList = this.channelList.filter((_, channelIndex) => channelIndex !== index);
		const firstUnpinnedChannelIndex = nextChannelList.findIndex(channel => !channel.channelFixationDate);

		if (!updatedChannel.channelFixationDate && firstUnpinnedChannelIndex !== -1) {
			nextChannelList.splice(firstUnpinnedChannelIndex, 0, updatedChannel);
		} else if (!updatedChannel.channelFixationDate) {
			nextChannelList.unshift(updatedChannel);
		} else {
			nextChannelList.splice(index, 0, updatedChannel);
		}

		this.applyChannelList(nextChannelList);
	}

	replaceOptimisticOrPush(message: ChatMessage) {
		this.completeAcknowledgedMessageReconciliation(message.clientMessageId);
		const optimisticMessageIndex = message.clientMessageId
			? this.messages.findIndex(existingMessage => existingMessage.clientMessageId === message.clientMessageId)
			: -1;
		const definitiveMessageIndex = message.id
			? this.messages.findIndex(existingMessage => existingMessage.id === message.id)
			: -1;

		if (optimisticMessageIndex !== -1) {
			this.$set(this.messages, optimisticMessageIndex, message);
			if (definitiveMessageIndex !== -1 && definitiveMessageIndex !== optimisticMessageIndex) {
				this.messages.splice(definitiveMessageIndex, 1);
			}
		} else if (definitiveMessageIndex === -1) {
			this.messages.push(message);
		} else {
			this.$set(this.messages, definitiveMessageIndex, message);
		}
	}

	markOptimisticMessageAsFailed(clientMessageId?: string) {
		if (!clientMessageId) return;

		this.completeAcknowledgedMessageReconciliation(clientMessageId);
		const optimisticMessageIndex = this.messages.findIndex(message => message.clientMessageId === clientMessageId);
		if (optimisticMessageIndex === -1) return;

		this.$set(this.messages, optimisticMessageIndex, {
			...this.messages[optimisticMessageIndex],
			status: ChatMessageStatus.FAILED,
		});
	}

	scheduleAcknowledgedMessageReconciliation(clientMessageId: string, messageId: string) {
		const optimisticMessage = this.messages.find(message => message.clientMessageId === clientMessageId);
		if (!optimisticMessage) return;

		this.completeAcknowledgedMessageReconciliation(clientMessageId);
		const timer = setTimeout(() => {
			void this.reconcileAcknowledgedMessage(clientMessageId, messageId, optimisticMessage.chatChannel);
		}, ACKNOWLEDGED_MESSAGE_RECONCILIATION_DELAY_MILLISECONDS);
		this.acknowledgedOptimisticMessages.set(clientMessageId, {
			chatChannelId: optimisticMessage.chatChannel,
			messageId,
			timer,
		});
	}

	async reconcileAcknowledgedMessage(clientMessageId: string, messageId: string, chatChannelId: string) {
		const acknowledgedMessage = this.acknowledgedOptimisticMessages.get(clientMessageId);
		if (!acknowledgedMessage || acknowledgedMessage.messageId !== messageId) return;

		try {
			const messages = await this.getMessages({ chatChannel: chatChannelId });
			const persistedMessage = messages.find((message: any) => message.id === messageId);
			if (persistedMessage && this.currentChatChannel?.id === chatChannelId) {
				this.replaceOptimisticOrPush({ ...persistedMessage, clientMessageId });
			}
		} finally {
			this.completeAcknowledgedMessageReconciliation(clientMessageId);
		}
	}

	completeAcknowledgedMessageReconciliation(clientMessageId?: string) {
		if (!clientMessageId) return;

		const acknowledgedMessage = this.acknowledgedOptimisticMessages.get(clientMessageId);
		if (acknowledgedMessage) clearTimeout(acknowledgedMessage.timer);
		this.acknowledgedOptimisticMessages.delete(clientMessageId);
	}

	applyMessageSnapshot(messages: ChatMessage[], chatChannelId: string) {
		const acknowledgedMessagesById = new Map(
			Array.from(this.acknowledgedOptimisticMessages.entries()).map(([clientMessageId, acknowledgedMessage]) => [
				acknowledgedMessage.messageId,
				clientMessageId,
			]),
		);
		const clientMessageIdsInSnapshot = new Set<string>();
		const reconciledMessages = messages.map(message => {
			const clientMessageId = acknowledgedMessagesById.get(message.id);
			if (!clientMessageId) return message;

			clientMessageIdsInSnapshot.add(clientMessageId);
			return { ...message, clientMessageId };
		});
		const messageIdsInSnapshot = new Set(reconciledMessages.map(message => message.id));
		const correlatedMessagesMissingFromSnapshot = this.messages.filter(
			message =>
				message.chatChannel === chatChannelId &&
				!!message.clientMessageId &&
				!messageIdsInSnapshot.has(message.id) &&
				!clientMessageIdsInSnapshot.has(message.clientMessageId),
		);

		this.messages = [...reconciledMessages, ...correlatedMessagesMissingFromSnapshot];
	}

	async addNewChatMessage(message: any) {
		this.registerWebSocketFact(message);
		const foundChannelIndex = this.channelList.findIndex(channel => channel.id === message.chatChannel);
		if (foundChannelIndex !== -1 && this.channelList[foundChannelIndex].id === this.currentChatChannel?.id) {
			const shouldScrollToBottom = this.isScrollAtBottom();
			this.replaceOptimisticOrPush(message);
			await this.assignMessageAndUpdateList(message, foundChannelIndex);

			if (shouldScrollToBottom) {
				this.$nextTick(() => {
					this.scrollToBottom();
				});
			}
		} else if (foundChannelIndex !== -1) {
			await this.assignMessageAndUpdateList(message, foundChannelIndex);
		} else if (foundChannelIndex === -1 && this.currentChatChannel?.id === message?.chatChannel) {
			const shouldScrollToBottom = this.isScrollAtBottom();
			this.replaceOptimisticOrPush(message);
			this.scheduleMissingChannelDiscovery(message.chatChannel, message);

			if (shouldScrollToBottom) {
				this.$nextTick(() => {
					this.scrollToBottom();
				});
			}
		} else {
			this.scheduleMissingChannelDiscovery(message.chatChannel, message);
		}
	}

	async reconcileChannels(purpose: ChannelReconciliationPurpose) {
		const compatiblePendingRequest = Array.from(this.pendingChannelRequests.values()).find(
			request => request.componentGeneration === this.channelReconciliationGeneration,
		);
		if (compatiblePendingRequest) {
			compatiblePendingRequest.purposes.add(purpose);
			return compatiblePendingRequest.completion;
		}

		const requestIdentifier = ++this.channelRequestSequence;
		const request: ChannelRequest = {
			identifier: requestIdentifier,
			startedAt: Date.now(),
			purposes: new Set([purpose]),
			componentGeneration: this.channelReconciliationGeneration,
		};
		request.completion = this.executeChannelReconciliation(request);
		this.pendingChannelRequests.set(requestIdentifier, request);
		return request.completion;
	}

	async executeChannelReconciliation(request: ChannelRequest) {
		try {
			const channels = await this.chatModel.getChannels({ shouldIgnoreChannelStatus: true });
			if (request.componentGeneration !== this.channelReconciliationGeneration) return;
			this.applyChannelSnapshot(channels, request);
		} finally {
			this.settleChannelRequest(request.identifier);
		}
	}

	applyChannelSnapshot(channels: ChatChannel[], request: ChannelRequest) {
		const channelIdentifiersInSnapshot = new Set(channels.map(channel => channel.id));
		const discoveredChannelIdentifiers = Array.from(this.missingChannelDiscoveries.keys()).filter(channelIdentifier =>
			channelIdentifiersInSnapshot.has(channelIdentifier),
		);
		const isOlderSnapshot = request.identifier < this.lastAppliedChannelRequestIdentifier;

		if (isOlderSnapshot) {
			discoveredChannelIdentifiers.forEach(channelIdentifier => {
				const discoveredChannel = channels.find(channel => channel.id === channelIdentifier)!;
				const currentChannel = this.channelList.find(channel => channel.id === channelIdentifier);
				const mergedChannel = this.mergeWebSocketFact(discoveredChannel, request);
				if (!currentChannel) {
					this.applyChannelList(this.orderChannelsByWebSocketFacts([...this.channelList, mergedChannel]));
				}
				this.completeMissingChannelDiscovery(channelIdentifier);
			});
			return;
		}

		const nextChannelList = channels.map(channel => this.mergeWebSocketFact(channel, request));

		this.webSocketChannelFacts.forEach((fact, channelIdentifier) => {
			if (channelIdentifiersInSnapshot.has(channelIdentifier)) return;
			const currentChannel = this.channelList.find(channel => channel.id === channelIdentifier);
			if (currentChannel && fact.pendingRequestIdentifiers.has(request.identifier)) {
				nextChannelList.push(this.mergeWebSocketFact(currentChannel, request));
			}
		});

		this.channelList.forEach(currentChannel => {
			if (channelIdentifiersInSnapshot.has(currentChannel.id)) return;
			const fact = this.webSocketChannelFacts.get(currentChannel.id);
			const isProtectedByOlderRequest = !!fact && fact.pendingRequestIdentifiers.has(request.identifier);
			const isMissingChannelDiscoveryActive = this.missingChannelDiscoveries.has(currentChannel.id);
			if (isProtectedByOlderRequest || isMissingChannelDiscoveryActive) {
				nextChannelList.push(this.mergeWebSocketFact(currentChannel, request));
			}
		});

		this.applyChannelList(this.orderChannelsByWebSocketFacts(nextChannelList));
		this.lastAppliedChannelRequestIdentifier = request.identifier;
		discoveredChannelIdentifiers.forEach(channelIdentifier =>
			this.completeMissingChannelDiscovery(channelIdentifier),
		);
	}

	applyChannelList(nextChannelList: ChatChannel[]) {
		const didChange = !this.areChannelListsEquivalent(this.channelList, nextChannelList);
		if (didChange) {
			this.channelList = nextChannelList;
			this.reloadChatChannelListComponent();
		}
		return didChange;
	}

	areChannelListsEquivalent(currentChannelList: ChatChannel[], nextChannelList: ChatChannel[]) {
		if (currentChannelList.length !== nextChannelList.length) return false;
		return currentChannelList.every((channel, index) => {
			const nextChannel = nextChannelList[index];
			return (
				channel.id === nextChannel.id &&
				channel.channelFixationDate === nextChannel.channelFixationDate &&
				channel.lastChatMessage?.id === nextChannel.lastChatMessage?.id &&
				channel.lastChatMessage?.status === nextChannel.lastChatMessage?.status &&
				channel.lastChatMessage?.isRead === nextChannel.lastChatMessage?.isRead &&
				channel.lastChatMessage?.createdDate === nextChannel.lastChatMessage?.createdDate
			);
		});
	}

	mergeWebSocketFact(channel: ChatChannel, request: ChannelRequest): ChatChannel {
		const fact = this.webSocketChannelFacts.get(channel.id);
		const discovery = this.missingChannelDiscoveries.get(channel.id);
		// A later eligible snapshot may still carry an older projection, so preserve the
		// most recent WS fact until every request that predates it has settled.
		const latestMessage = fact?.latestMessage ?? discovery?.latestMessage;
		return latestMessage ? { ...channel, lastChatMessage: latestMessage } : { ...channel };
	}

	orderChannelsByWebSocketFacts(channels: ChatChannel[]) {
		const channelsWithPromotedPositions = channels
			.map(channel => ({ channel, fact: this.webSocketChannelFacts.get(channel.id) }))
			.filter(({ fact }) => fact);
		const orderedChannels = channels.filter(channel => !this.webSocketChannelFacts.has(channel.id));

		channelsWithPromotedPositions
			.sort((left, right) => left.fact!.promotedPosition - right.fact!.promotedPosition)
			.forEach(({ channel, fact }) =>
				orderedChannels.splice(Math.min(fact!.promotedPosition, orderedChannels.length), 0, channel),
			);

		return orderedChannels;
	}

	registerWebSocketFact(message: ChatMessage) {
		const pendingRequestIdentifiers = new Set<number>(this.pendingChannelRequests.keys());
		if (!pendingRequestIdentifiers.size) return;
		const channelIndex = this.channelList.findIndex(channel => channel.id === message.chatChannel);
		const channelsWithoutUpdatedChannel = this.channelList.filter(channel => channel.id !== message.chatChannel);
		const firstUnpinnedChannelIndex = channelsWithoutUpdatedChannel.findIndex(
			channel => !channel.channelFixationDate,
		);
		const currentChannel = channelIndex === -1 ? undefined : this.channelList[channelIndex];
		const promotedPosition = currentChannel?.channelFixationDate
			? channelIndex
			: firstUnpinnedChannelIndex === -1
			? 0
			: firstUnpinnedChannelIndex;
		this.webSocketChannelFacts.set(message.chatChannel, {
			channelIdentifier: message.chatChannel,
			sequence: ++this.webSocketFactSequence,
			latestMessage: message,
			promotedPosition,
			pendingRequestIdentifiers,
		});
	}

	settleChannelRequest(requestIdentifier: number) {
		this.pendingChannelRequests.delete(requestIdentifier);
		this.webSocketChannelFacts.forEach((fact, channelIdentifier) => {
			fact.pendingRequestIdentifiers.delete(requestIdentifier);
			if (!fact.pendingRequestIdentifiers.size) this.webSocketChannelFacts.delete(channelIdentifier);
		});
	}

	completeMissingChannelDiscovery(channelIdentifier: string) {
		const discovery = this.missingChannelDiscoveries.get(channelIdentifier);
		if (!discovery) return;
		if (discovery.retryTimer) clearTimeout(discovery.retryTimer);
		this.missingChannelDiscoveries.delete(channelIdentifier);
	}

	scheduleMissingChannelDiscovery(channelIdentifier: string, message: ChatMessage) {
		let discovery = this.missingChannelDiscoveries.get(channelIdentifier);
		if (!discovery) {
			discovery = { attemptCount: 0, latestMessage: message, retryTimer: undefined, isRequestInProgress: false };
			this.missingChannelDiscoveries.set(channelIdentifier, discovery);
		}
		discovery.latestMessage = message;
		if (discovery.retryTimer || discovery.isRequestInProgress) return;
		if (discovery.attemptCount >= MISSING_CHANNEL_RETRY_MAXIMUM_ATTEMPTS) {
			this.missingChannelDiscoveries.delete(channelIdentifier);
			return;
		}

		const delay =
			MISSING_CHANNEL_RETRY_INITIAL_DELAY_MILLISECONDS *
			Math.pow(MISSING_CHANNEL_RETRY_BACKOFF_MULTIPLIER, discovery.attemptCount);
		discovery.retryTimer = setTimeout(() => {
			void this.runMissingChannelDiscovery(channelIdentifier, discovery!);
		}, delay);
	}

	async runMissingChannelDiscovery(channelIdentifier: string, discovery: ChannelDiscovery) {
		discovery.retryTimer = undefined;
		if (this.missingChannelDiscoveries.get(channelIdentifier) !== discovery) return;
		discovery.isRequestInProgress = true;
		discovery.attemptCount += 1;
		try {
			await this.reconcileChannels("missingChannelDiscovery");
		} catch (error) {
			console.error("Unable to discover chat channel after a new message.", error);
		} finally {
			discovery.isRequestInProgress = false;
			if (this.missingChannelDiscoveries.get(channelIdentifier) === discovery) {
				this.scheduleMissingChannelDiscovery(channelIdentifier, discovery.latestMessage);
			}
		}
	}

	async getChannels(purpose: ChannelReconciliationPurpose) {
		await this.reconcileChannels(purpose);
	}

	async getMessages(getMessagesDto: GetMessagesDto) {
		return this.chatModel.getMessages(getMessagesDto);
	}

	async updateChannelMessagesStatus(getMessagesDto: GetMessagesDto) {
		return this.chatModel.updateChannelMessagesStatus(getMessagesDto);
	}

	async createOrOpenChatChannel(getDirectChannelDto: GetDirectChannelDto) {
		return this.chatModel.getDirectChannel(getDirectChannelDto);
	}

	async bindClientsToChannel(clients: string[], chatChannel: string) {
		return this.chatModel.bindClientsToChannel(clients, chatChannel);
	}

	async pinChatChannelOnQueue(chatChannel: string) {
		return this.chatModel.pinChatChannelOnQueue(chatChannel);
	}

	async searchClient(event: Event) {
		try {
			this.isClientsLoading = true;
			const searchParam = this.searchParam?.length ? this.searchParam : undefined;
			const request = await this.model.getClientList({
				page: 1,
				limit: 15,
				sort: {
					property: "client.name",
					type: "ASC",
				},
				searchParam,
			});
			this.clientsList = request.data;
		} catch (error) {
			showErrorAlert((<any>error)?.message ?? "Ocorreu um erro. Tente novamente.");
		} finally {
			this.isClientsLoading = false;
		}
	}

	async loadMoreMessages() {
		if (!this.shouldShowUploadPreview) {
			try {
				const scrollContainerElement = document.getElementById("scrollContainer");

				if (this.isChatOpened && scrollContainerElement && scrollContainerElement.scrollTop === 0) {
					const lastMessageCreatedDate = this.messages[0].createdDate;
					const chatChannel = this.currentChatChannel.id;
					const foundMessages = (
						await this.getMessages({ chatChannel, lastChatMessageDate: lastMessageCreatedDate })
					).reverse();
					if (foundMessages.length) {
						// Salva a altura atual do scroll antes de adicionar mensagens
						const previousScrollHeight = scrollContainerElement.scrollHeight;

						this.messages.unshift(...foundMessages);

						// Aguarda o DOM atualizar e ajusta o scroll para manter a posição relativa
						await this.$nextTick();
						const newScrollHeight = scrollContainerElement.scrollHeight;
						const scrollDifference = newScrollHeight - previousScrollHeight;

						// Mantém o scroll um pouco acima do topo para permitir continuar carregando
						scrollContainerElement.scrollTop = scrollDifference * 0.3;
					}
				}
			} catch (error) {
				showErrorAlert((<any>error)?.message ?? "Ocorreu um erro. Tente novamente.");
			}
		}
	}

	scrollToBottom() {
		const element = document.getElementById("chatContainer");
		if (element) {
			element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
		}
		// Garante que o botão seja ocultado após o scroll
		setTimeout(() => {
			this.showScrollButton = false;
		}, 100);
	}

	isScrollAtBottom() {
		const scrollContainer = document.getElementById("scrollContainer");
		if (!scrollContainer) return true;

		return scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - 10;
	}

	handleScroll() {
		const scrollContainer = document.getElementById("scrollContainer");
		if (scrollContainer) {
			const scrollTop = scrollContainer.scrollTop;

			// Detecta se está no final (margem de 10px)
			const isAtBottom = this.isScrollAtBottom();

			// Detecta direção do scroll
			const isScrollingUp = scrollTop < this.lastScrollTop;

			// Mostra o botão se: scrollar para cima OU não estiver no final
			if (isScrollingUp && !isAtBottom) {
				this.showScrollButton = true;
			} else if (isAtBottom) {
				// Esconde o botão apenas se estiver no final
				this.showScrollButton = false;
			}

			// Atualiza última posição de scroll
			this.lastScrollTop = scrollTop;
		}
	}

	handleScrollEvents() {
		this.debouncedGetMoreMessages();
		this.debouncedHandleScroll();
	}

	changeShowMessageAlertStatus() {
		this.shouldShowMessageSendAlert = false;
		const journeyInput = <HTMLInputElement>document.getElementById("journey-input");
		journeyInput.focus();
	}

	changeInputHeight(text: string) {
		const journeyInput = <HTMLInputElement>document.getElementById("journey-input");
		if (journeyInput.scrollHeight < 250) {
			journeyInput.style.height = `${journeyInput.scrollHeight}px`;
			if (!text.length || text.length < 105) {
				journeyInput.style.height = "45px";
			}
		} else if (journeyInput.scrollHeight >= 250) {
			journeyInput.style.height = "250px";
			if (!text.length || text.length < 105) {
				journeyInput.style.height = "45px";
			}
		}
	}

	sendMessage(
		event?: KeyboardEvent,
		hsm?:
			| {
					id: string;
					contentVariables: { referenceKey: string; value: string }[];
					message: string;
					shouldNotUseAI: boolean;
			  }
			| undefined,
	) {
		//Caso não tenha a conversa liberada, Obrigatório messageTemplate
		if (event?.shiftKey) {
			this.messageText += "\n";
			this.changeInputHeight(this.messageText);
		} else {
			try {
				const mediaFiles: string[] | undefined = this.uploadedFile ? [this.uploadedFile.fileName] : undefined;
				if (!mediaFiles?.length || (mediaFiles?.length && !this.shouldShowMessageSendAlert)) {
					const text: string = hsm?.message ?? this.messageText;
					const contentVariables: { referenceKey: string; value: string }[] | undefined = hsm?.contentVariables;
					const metadata: undefined = undefined;
					const messageTemplate: string | undefined = hsm?.id ?? undefined;
					const isMediaCopy = this.isMediaCopy;
					const clientMessageId = uuidv4();
					this.shouldShowMessageSendAlert = true;
					if (this.currentChatChannel) {
						sendMessageSocket(
							this.currentChatChannel.id,
							text,
							contentVariables,
							mediaFiles,
							metadata,
							messageTemplate,
							hsm ? !hsm?.shouldNotUseAI : undefined,
							isMediaCopy,
							clientMessageId,
						);

						const optimisticMediaFiles =
							mediaFiles && this.mediaPreview && this.fileType ? [`${this.mediaPreview}#file.${this.fileType}`] : [];
						const optimisticMessage = {
							id: `temp-${Date.now()}`,
							text: text || "",
							user: this.activeUser,
							chatChannel: this.currentChatChannel.id,
							status: ChatMessageStatus.QUEUED,
							createdDate: new Date(),
							kind: ChatMessageKind.DEFAULT,
							mediaFiles: optimisticMediaFiles,
							clientMessageId,
						} as ChatMessage;
						this.messages.push(optimisticMessage);
						this.$nextTick(() => {
							this.scrollToBottom();
						});

						this.messageText = "";
						this.saveSketch("");
						this.unsetUploadFileVariables();
						this.changeInputHeight("");
					}
				} else if (this.shouldShowMessageSendAlert && mediaFiles?.length) {
					this.isMessageSendAlertModalOpen = true;
				}
			} catch (error) {
				showErrorAlert((<any>error)?.message ?? "Ocorreu um erro. Tente novamente.");
			} finally {
			}
		}
	}

	validateIsWithinAllowedNonTemplateMessages(then?: Date) {
		const now = new Date();
		const isWithinTheAllowedTime = then
			? !!(Math.abs(new Date(then).getTime() - now.getTime()) / (60 * 60 * 1000) < 24)
			: false; // Diferença em horas entre duas datas
		return isWithinTheAllowedTime;
	}

	async startConversation(chatChannel: ChatChannel, isReconnection?: boolean) {
		try {
			this.isChatLoading = true;
			this.emojiModalIsOpen = false;
			this.clientModalIsOpen = false;
			this.mainChatMemberModalIsOpen = false;
			this.currentChatChannel = chatChannel;
			this.mainChatChannelMember.id = "";
			this.mainChatChannelMember.fullName = "";
			if (!this.isReconnection) this.messageText = "";
			const messageSnapshotRequestIdentifier = ++this.messageSnapshotRequestSequence;
			const messages = await this.getMessages({ chatChannel: chatChannel.id });
			if (
				messageSnapshotRequestIdentifier !== this.messageSnapshotRequestSequence ||
				this.currentChatChannel.id !== chatChannel.id
			) {
				return;
			}
			this.applyMessageSnapshot(messages.reverse(), chatChannel.id);
			const isMessagesUpdated = await this.updateChannelMessagesStatus({ chatChannel: chatChannel.id });

			if (isMessagesUpdated) {
				this.currentChatChannel.lastChatMessage.status = ChatMessageStatus.READ;
			}
		} catch (error) {
			showErrorAlert((<any>error)?.message ?? "Ocorreu um erro. Tente novamente.");
		} finally {
			this.isChatLoading = false;
			this.isChatOpened = true;
			this.clientPhoneNumber = this.currentChatChannel.phoneNumber;

			// Scroll inicial para o final do chat
			this.$nextTick(() => {
				this.scrollToBottom();
			});

			const foundChatMember = this.currentChatChannel.chatMembers.find(member => member.isMainMember);
			if (foundChatMember) {
				this.mainChatChannelMember.id = foundChatMember.id;
				this.mainChatChannelMember.fullName = foundChatMember?.client
					? this.formatClientFullName(foundChatMember.client)
					: "";
				if (typeof isReconnection === "boolean" && isReconnection) {
					this.isReconnection = false;
					return;
				}
				this.openClientProfile(foundChatMember.client!);
			} else {
				if (typeof isReconnection === "boolean" && isReconnection) {
					this.isReconnection = false;
					return;
				}
				this.customerProfileComponentKey += 1;
				this.foundClientId = "";
			}

			this.isReconnection = false;
			this.loadSketch();
		}
	}

	formatClientFullName(client: Partial<Client>) {
		return `${client.name}${client.lastName ? " " + client.lastName : ""}`;
	}

	async createOrOpenConversationOnlyWithPhoneNumber(
		phoneNumber: string,
		shouldSendReceptiveMessage: boolean,
		corporateClientId: string,
	) {
		await this.createOrOpenConversation(<Partial<Client>>phoneNumber, shouldSendReceptiveMessage, corporateClientId);
	}

	async createOrOpenConversation(
		client: Partial<Client>,
		shouldSendReceptiveMessage?: boolean,
		corporateClientId?: string,
		chatChannelId?: string,
	) {
		try {
			if (this.clientModalIsOpen) {
				this.clientModalIsOpen = false;
			}
			if (!client.phoneNumber) {
				return;
			}
			if (
				this.currentChatChannel &&
				(chatChannelId
					? this.currentChatChannel.phoneNumber === client.phoneNumber &&
					  this.currentChatChannel.corporateClient.id === corporateClientId
					: this.currentChatChannel.phoneNumber === client.phoneNumber) &&
				this.isChatOpened
			) {
				return;
			}
			this.isChatLoading = true;
			const newChatChannel = await this.createOrOpenChatChannel({
				client: client?.id,
				phoneNumber: client.phoneNumber,
				shouldSendReceptiveMessage,
				corporateClientId: corporateClientId,
				chatChannelId,
			});
			const foundChannelInList = this.channelList?.find(channel => channel.id === newChatChannel.id);
			if (!foundChannelInList) {
				await this.getChannels("createOrOpen");
			}
			await this.startConversation(newChatChannel);
			this.isChatOpened = true;
		} catch (error) {
			showErrorAlert((<any>error)?.message ?? "Ocorreu um erro. Tente novamente.");
		} finally {
			this.searchParam = "";
			this.clientsList = [];
			this.isChatLoading = false;
			this.userCalendarIsOpen = false;
		}
	}

	async relateClientToChannel(client: Client) {
		try {
			if (this.clientModalIsOpen) {
				this.clientModalIsOpen = false;
			}

			if (this.currentChatChannel) {
				const [chatMember] = await this.bindClientsToChannel([client.id], this.currentChatChannel.id);
				this.currentChatChannel.chatMembers.push(chatMember);
				showSuccessAlert("Relação adicionada com sucesso.");
			} else {
				showErrorAlert("Abra um canal antes de víncular um cliente.");
			}
		} catch (error) {
			showErrorAlert((<any>error)?.message ?? "Ocorreu um erro. Tente novamente.");
		} finally {
		}
	}

	openClientProfile(client: Client) {
		if (this.clientModalIsOpen) {
			this.clientModalIsOpen = false;
		}

		this.customerProfileComponentKey += 1;
		this.foundClientId = client.id;
	}

	reloadCustomerProfileComponent() {
		this.customerProfileComponentKey += 1;
	}

	reloadMainChatMemberComponent() {
		this.mainChatMemberComponentKey += 1;
	}

	reloadChatChannelListComponent() {
		this.channelListComponentKey += 1;
	}

	selectEmoji(emoji: { category: string; data: string }) {
		this.messageText += emoji.data;
		this.changeEmojiModalStatus(false);
	}

	changeEmojiModalStatus(status: boolean) {
		this.emojiModalIsOpen = status;
	}

	changeMainChatMemberModalStatus(status: boolean) {
		this.mainChatMemberModalIsOpen = status;
	}

	closeModal() {
		this.hsmModalIsOpen = false;
		this.standardModalIsOpen = false;
		this.clientModalIsOpen = false;
		this.userModalIsOpen = false;
		this.userCalendarIsOpen = false;
		this.confirmationModalIsOpen = false;
		this.chooseChannelIsOpen = false;
		this.isMessageSendAlertModalOpen = false;
		this.openChannelWithNumberIsOpen = false;
	}

	openClientSearchModal(eventType: string) {
		this.eventType = eventType;
		this.clientModalIsOpen = true;
	}

	openUserSearchModal() {
		this.userModalIsOpen = true;
	}

	openConfirmationModal() {
		this.confirmationModalIsOpen = true;
	}

	inputMask() {
		return getMask("tel");
	}

	updateChannelMembersMainStatus(updatedChatMembers: ChatMember[]) {
		this.channelList
			.find(channel => channel.id === this.currentChatChannel.id)
			?.chatMembers.forEach(member => {
				const foundUpdatedChatMember = updatedChatMembers.find(
					updatedChatMember => updatedChatMember.id === member.id,
				);
				if (foundUpdatedChatMember) {
					member.isMainMember = foundUpdatedChatMember.isMainMember;
				}
			});
		this.channelListComponentKey += 1;
	}

	async mainChatMemberActions(data: ChatMember, action: "delete" | "update") {
		try {
			if (action === "update") {
				const updatedChatMembers: ChatMember[] = await this.chatModel.setChatChannelMainClientMember(
					data.id,
					this.currentChatChannel.id,
				);

				this.currentChatChannel.chatMembers.forEach((chatMember, chatMemberIndex) => {
					const foundChatMember = updatedChatMembers.find(
						updatedChatMember => updatedChatMember.id === chatMember.id,
					);
					if (foundChatMember) {
						this.currentChatChannel.chatMembers[chatMemberIndex].isMainMember = foundChatMember.isMainMember;
					}
				});
				const newMainChatChannelMember = this.currentChatChannel.chatMembers.find(
					updatedChatMember => updatedChatMember.isMainMember,
				);
				if (newMainChatChannelMember) {
					this.mainChatChannelMember.id = newMainChatChannelMember!.id;
					this.mainChatChannelMember.fullName = newMainChatChannelMember?.client
						? this.formatClientFullName(newMainChatChannelMember.client)
						: "";
				} else {
					this.mainChatChannelMember.id = "";
					this.mainChatChannelMember.fullName = "";
				}
				this.updateChannelMembersMainStatus(updatedChatMembers);
				this.mainChatMemberModalIsOpen = !this.mainChatMemberModalIsOpen;
				if (newMainChatChannelMember) {
					this.openClientProfile(newMainChatChannelMember!.client!);
				}

				showSuccessAlert("Alteração realizada com sucesso.");
			} else if (action === "delete") {
				const response: boolean = await this.chatModel.deleteChatChannelMainClientMember(
					data.id,
					this.currentChatChannel.id,
				);
				if (response) {
					const currentMembers = this.channelList.find(
						channel => channel.id === this.currentChatChannel.id,
					)?.chatMembers;
					const foundChatMemberIndex = currentMembers
						? currentMembers.findIndex(member => member.id === data.id)
						: -1;

					if (foundChatMemberIndex !== -1 && currentMembers) {
						currentMembers.splice(foundChatMemberIndex, 1);
						this.currentChatChannel.chatMembers = currentMembers;
						this.reloadMainChatMemberComponent();
						this.updateChannelMembersMainStatus(currentMembers);
					}
					if (this.mainChatChannelMember.id === data.id) {
						this.mainChatChannelMember.id = "";
						this.mainChatChannelMember.fullName = "";
					}
					this.mainChatMemberModalIsOpen = !this.mainChatMemberModalIsOpen;
				}

				showSuccessAlert("Relação removida com sucesso.");
			}

			// this.mainChatMemberModalIsOpen = false;
		} catch (error) {
			showErrorAlert((<any>error)?.message ?? "Ocorreu um erro. Tente novamente.");
		} finally {
		}
	}

	get chatMembersList() {
		return this.currentChatChannel.chatMembers;
	}

	openUserCalendarModal() {
		this.userCalendarIsOpen = true;
	}

	async updateUserWorkStatus() {
		try {
			const newStatusValue: UserWorkStatus =
				this.activeUser.workStatus === UserWorkStatus.ACTIVE ? UserWorkStatus.AWAY : UserWorkStatus.ACTIVE;
			const updatedUser = await this.userAppModel.updateProfile({ workStatus: newStatusValue });
			this.activeUser.workStatus = updatedUser.workStatus;
			this.changeWorkStatusIconColor();
		} catch (error) {
			showErrorAlert((<any>error)?.message ?? "Ocorreu um erro. Tente novamente.");
		} finally {
			showSuccessAlert("Status alterado com sucesso.");
		}
	}

	changeWorkStatusIconColor() {
		this.workStatusIconStyle =
			this.activeUser.workStatus === UserWorkStatus.ACTIVE
				? "h-7 font-bold text-journey-weak-blue"
				: "h-7 font-bold text-journey-red";
	}

	sendHSM(hsmMessage: {
		id: string;
		contentVariables: { referenceKey: string; value: string }[];
		message: string;
		shouldNotUseAI: boolean;
	}) {
		this.sendMessage(undefined, hsmMessage);
		this.hsmModalIsOpen = false;
	}

	chooseStandardMessage(standardMessage: { id: string; text: string }) {
		const journeyInput = <HTMLInputElement>document.getElementById("journey-input");
		journeyInput.value = "";
		journeyInput.value = standardMessage.text;
		this.changeInputHeight(standardMessage.text);
		this.messageText = standardMessage.text;
		journeyInput.setAttribute("value", standardMessage.text);
		journeyInput.focus();
		this.standardModalIsOpen = false;
	}

	async handleCopyToChat(payload: { text: string; attachmentUrl?: string }) {
		if (!this.isChatOpened || !this.currentChatChannel) {
			showErrorAlert("Abra uma conversa antes de colar a solução.");
			return;
		}

		const solutionText = payload.text ?? "";
		if (solutionText) {
			navigator.clipboard?.writeText(solutionText)?.catch(() => undefined);
		}

		const nextMessageText = [this.messageText, solutionText].filter(Boolean).join(this.messageText ? "\n" : "");
		this.messageText = nextMessageText;
		const journeyInput = <HTMLInputElement>document.getElementById("journey-input");
		if (journeyInput) {
			journeyInput.value = nextMessageText;
			this.changeInputHeight(nextMessageText);
			journeyInput.focus();
		}
		this.saveSketch(nextMessageText);

		if (payload.attachmentUrl) {
			const urlParts = payload.attachmentUrl.split("/");
			const fileName = urlParts[urlParts.length - 1] || "attachment";
			this.fileType = fileName.split(".").pop();
			this.shouldShowUploadPreview = true;
			this.uploadedFile = { fileName: payload.attachmentUrl };
			this.mediaPreview = payload.attachmentUrl;
			const journeyInput = <HTMLInputElement>document.getElementById("journey-input");
			if (journeyInput) journeyInput.focus();
			this.isMediaCopy = true;
		}

		showSuccessAlert("", "Solução colada no chat.");
	}

	async pinChannel(channel: ChatChannel) {
		const successMessage = channel.channelFixationDate
			? "Canal desafixado com sucesso."
			: "Canal fixado com sucesso.";
		try {
			const response = await this.pinChatChannelOnQueue(channel.id);
			if (response) {
				this.isChannelsLoading = true;
				await this.getChannels("pin");
				this.isChannelsLoading = false;
				showSuccessAlert(successMessage);
			}
		} catch (error) {
			showErrorAlert((<any>error)?.message ?? "Ocorreu um erro. Tente novamente.");
		}
	}

	async transferChannel(cardData: IUser) {
		try {
			transferChannel(this.currentChatChannel.id, cardData.id!);
			this.foundClientId = "";
			this.customerProfileComponentKey += 1;
			this.userModalIsOpen = false;
		} catch (error) {
			showErrorAlert((<any>error)?.message ?? "Ocorreu um erro. Tente novamente.");
		}
	}

	async closeChannel() {
		try {
			const currentChatChannel = this.currentChatChannel;
			const response = await this.chatModel.closeChannel(currentChatChannel.id);
			if (response) {
				this.currentChatChannel.id = "";
				this.updateChannelList();
				await this.getChannels("close");
				this.isChannelsLoading = false;
				this.foundClientId = "";
				this.customerProfileComponentKey += 1;
				showSuccessAlert("Canal encerrado com sucesso.");
			}
		} catch (error) {
			showErrorAlert((<any>error)?.message ?? "Ocorreu um erro. Tente novamente.");
		}
	}

	formatSubTitleConfirmationModal() {
		if (this.currentChatChannel) {
			return `A conversa${
				this.mainChatChannelMember.fullName
					? " com o cliente <b class='text-journey-black'>" + this.mainChatChannelMember.fullName + "</b>"
					: ""
			} referente ao número <b class="text-journey-black">${
				this.currentChatChannel.phoneNumber
			}</b> será encerrada. Clique em sim para confirmar a operação.`;
		}

		return "";
	}

	async getImage(event: any) {
		let items = event.clipboardData.items;
		for (let itemIndex in items) {
			let item = items[itemIndex];

			if (item.kind === "file") {
				await this.uploadFile(undefined, item.getAsFile());
			}
		}
	}

	get propCurrentTime() {
		return this.currentTime;
	}

	updateCurrentTime() {
		this.currentTimeInterval = null;
		this.currentTimeInterval = setInterval(() => {
			this.currentTime = new Date();
		}, 30000);
	}

	beforeDestroy() {
		this.channelReconciliationGeneration += 1;
		this.messageSnapshotRequestSequence += 1;
		this.missingChannelDiscoveries.forEach(discovery => {
			if (discovery.retryTimer) clearTimeout(discovery.retryTimer);
		});
		this.missingChannelDiscoveries.clear();
		this.acknowledgedOptimisticMessages.forEach(acknowledgedMessage => clearTimeout(acknowledgedMessage.timer));
		this.acknowledgedOptimisticMessages.clear();
		this.pendingChannelRequests.clear();
		this.webSocketChannelFacts.clear();
		if (this.currentTimeInterval) {
			clearInterval(this.currentTimeInterval);
			this.currentTimeInterval = null;
		}
	}
}
